import {
  ScopeReportLineItemWithChangeData,
} from '../ScopeReportTypes';

/**
 * Filters a flat array of line items to only include items with change order data.
 *
 * This function takes the output of computeDiff() and returns only the line items
 * that have changes (new, deleted, or modified items).
 *
 * @param lineItems - Flat array of line items with optional changeOrderData
 * @returns Array of line items that have changeOrderData attached
 */
export const filterChangeOrderLineItems = (
  lineItems: ScopeReportLineItemWithChangeData[],
): ScopeReportLineItemWithChangeData[] => lineItems.filter(item => !!item.changeOrderData);
